import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withStyles from '@material-ui/core/styles/withStyles'
import Input from '@material-ui/core/Input'
import compose from 'recompose/compose'
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys'
import cx from 'classnames'

const styles = (theme) => ({
  field: {
    margin: theme.spacing.unit,
  },
})

const renderInputField = ({
  input,
  meta: { touched, error },
  ...customProps
}) => {
  return (
    // TODO: add error msg
    <div>
      {error && error}
      <Input error={touched && !!error} {...input} {...customProps} />
    </div>
  )
}

const ReduxFormInput = (props) => {
  const {
    classes,
    className,
    id,
    autoFill,
    inputRef,
    name,
    fullWidth,
    required,
    rows,
    rowsMax,
    multiline,
    ...restProps
  } = props
  return (
    <Field
      id={id}
      autoComplete={`section-red shipping ${autoFill}`}
      inputProps={{
        className: cx({ [className]: !!className }, classes.field),
      }}
      inputRef={inputRef}
      name={name}
      component={renderInputField}
      fullWidth={fullWidth && true}
      required={!!required}
      rows={rows || 8}
      rowsMax={rowsMax || 10}
      multiline={!!multiline}
      {...restProps}
    />
  )
}

export default compose(
  onlyUpdateForKeys(['className']),
  withStyles(styles)(ReduxFormInput),
)



// WEBPACK FOOTER //
// ./src/components/ReduxFormInput.js